import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import { Snackbar, Alert } from "@mui/material";

export default function BankRedirect() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const showSnackbar = (message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  };

  useEffect(() => {
    const ref = searchParams.get("ref");

    if (!ref) {
      showSnackbar("Missing redirect reference", "error");
      return navigate("/dashboard/settings");
    }

    const confirmBankConnection = async () => {
      try {
        const res = await api.get(`/bank/status/ref/${ref}`);
        const target = res.data.redirectTo || "/dashboard/settings";

        showSnackbar("✅ Bank connected successfully", "success");

        setTimeout(() => {
          navigate(target);
        }, 1500);
      } catch (err) {
        console.error("Failed to confirm bank connection", err);
        showSnackbar("❌ Could not confirm bank connection", "error");

        setTimeout(() => {
          navigate("/dashboard/settings");
        }, 1500);
      }
    };

    confirmBankConnection();
  }, [searchParams, navigate]);

  return (
    <>
      <div style={{ padding: "2rem", textAlign: "center" }}>
        🔄 Finishing bank connection...
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={snackbar.severity} variant="filled">
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
